var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetitionsEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 721,
    height: 400,
    viewBox: "0 0 721 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2391_108136)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720.833,
    height: 400,
    rx: 18.9911,
    fill: "#011224"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0012207,
    y1: -0.00432634,
    x2: 721.663,
    y2: -0.00432634,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0012207,
    y1: 66.4644,
    x2: 721.663,
    y2: 66.4644,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0012207,
    y1: 132.933,
    x2: 721.663,
    y2: 132.933,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0012207,
    y1: 199.402,
    x2: 721.663,
    y2: 199.402,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0012207,
    y1: 265.871,
    x2: 721.663,
    y2: 265.871,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0012207,
    y1: 332.34,
    x2: 721.663,
    y2: 332.34,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0012207,
    y1: 398.809,
    x2: 721.663,
    y2: 398.809,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.886,
    y1: 5.1883e-8,
    x2: 646.886,
    y2: 398.813,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.462,
    y1: 5.1883e-8,
    x2: 485.462,
    y2: 398.813,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.037,
    y1: 5.1883e-8,
    x2: 324.037,
    y2: 398.813,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.613,
    y1: 5.1883e-8,
    x2: 162.613,
    y2: 398.813,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.18865,
    y1: 5.1883e-8,
    x2: 1.18864,
    y2: 398.813,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.49561,
    y: 9.49438,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4325,
    cy: 33.2333,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 23.8318,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 35.5837,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.342,
    y: 9.49438,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.279,
    cy: 33.2333,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.381,
    y: 23.8318,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.381,
    y: 35.5837,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.768,
    y: 143.62,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.705,
    cy: 167.359,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.807,
    y: 157.957,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.807,
    y: 169.709,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.48,
    y: 276.562,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.417,
    cy: 300.301,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.52,
    y: 290.9,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.52,
    y: 302.652,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.768,
    y: 343.023,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.705,
    cy: 366.762,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.807,
    y: 357.36,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.807,
    y: 369.112,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.49561,
    y: 77.1484,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4325,
    cy: 100.887,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 91.4858,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 103.238,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.49561,
    y: 143.62,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4325,
    cy: 167.359,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 157.957,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 169.709,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.49561,
    y: 210.091,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4325,
    cy: 233.83,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 224.428,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 236.18,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.49561,
    y: 276.562,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4325,
    cy: 300.301,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 290.9,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 302.652,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.49561,
    y: 343.023,
    width: 142.433,
    height: 47.4777,
    rx: 12.5354,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.4325,
    cy: 366.762,
    r: 9.40153,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 357.36,
    width: 37.6061,
    height: 7.05115,
    rx: 3.52558,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5349,
    y: 369.112,
    width: 93.8586,
    height: 7.05115,
    rx: 3.52558,
    fill: "#E5E5D6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.18694,
    y: 1.18694,
    width: 718.459,
    height: 397.626,
    rx: 17.8042,
    stroke: "#0D1B29",
    strokeWidth: 2.37389
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2391_108136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720.833,
    height: 400,
    rx: 18.9911,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionsEmptyState);
export default __webpack_public_path__ + "static/media/competitions-empty-state.7b7de805c1dc305c897d59fac8744d77.svg";
export { ForwardRef as ReactComponent };